<template>
  <section class="section store-nearby-wrapper">
    <div class="container">
      <h3 class="title">
        <div class="level">
          <div class="level-left">
            <div class="level-item store-nearby-heading">Stores Nearby</div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <router-link
                class=" is-pulled-right has-text-black is-size-14"
                :to="{name: 'StoreLocations'}"
              >Show all ({{ locationnearby.length }})</router-link>
            </div>
          </div>
        </div>
      </h3>
      <div class="location-list" v-if="locationnearby.length == 0">
        <p class="text-center">No location found.</p>
      </div>
      <div class="location-list slider-wrapper" v-if="locationnearby.length > 0">
        <carousel
          :autoplay="false"
          :nav="true"
          :items="3"
          :margin="5"
          :dots="false"
          :responsive="{ 0:{items:1,nav:false}, 600:{items:2,nav:false}, 991:{items:3,nav:false}, 1024:{items: 3,nav:false }, 1368:{items: 3,nav:false}, }"
        >
          <div v-for="(item, index) in locationnearby" v-bind:key="index" ><!-- class="columns is-multiline" -->
            <div class="location-block" style="margin:10px;">
              <a href="#" @click.prevent="gotoStoreLanding(item)">
                <div class="location-image">
                  <img
                    v-if="getStorefeaturedImage(item.images)"
                    :src="getStorefeaturedImage(item.images)"
                    alt="image"
                    class="main-image"
                  />
                  <img v-else class="main-image" src="@/assets/img/home-banner.jpg"/>
                </div>
                <div class="location-info" style="height: 60px;">
                  <div class="columns is-mobile">
                    <div class="column is-8">
                      <div class="location-address">
                        <img src="@/assets/img/icon-marker.svg" alt="marker" class="marker"/>
                        <h3 class="title">{{item.display_name}}</h3>
                        <p
                          class="address"
                        >{{item.address_line_1}} {{item.address_line_2 ? ', ' + item.address_line_2:''}}</p>
                      </div>
                    </div>
                    <div class="column is-4 has-text-right">
                      <p
                        class="location-distance"
                        v-if="item.distance"
                      >{{ item.distance ? item.distance.toFixed(2) : 'N/A' }} KM</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <template slot="prev">
            <a class="nav-button button-prev">
              <img src="@/assets/img/icon-nav-arrow-left.svg" alt="prev" />
            </a>
          </template>

          <template slot="next" >
            <a class="nav-button button-next" v-show="locationnearby.length > 3">
              <img src="@/assets/img/icon-nav-arrow-right.svg" alt="next" />
            </a>
          </template>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import carousel from "vue-owl-carousel";
import "vueperslides/dist/vueperslides.css";
import LocationApis from '@/Components/Controllers/LocationApis';
import { isEmpty, find } from "lodash";

export default {
  components: { carousel },
  data() {
    return {
     
    };
  },
  props: {
    locationnearby: {
      required: true,
      type: Array
    },
  },

  async mounted() {
    
  },

  computed: {
    ...mapGetters({
      // vg_userAddress: "location/userAddress",
      // vg_guestLandedQueries: "location/guestLandedQueries",
    })
  },

  watch: {
    // 'vg_userAddress': function() {
    //   // LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry)
    // },
    // locationNearBy: {
    //   handler: function (val, oldVal) {
    //     this.loaded = false;
    //     this.$nextTick(() => {
    //       this.loaded = true;
    //     }, 1000)
    //   },
    //   deep: true
    // }
  },

  methods: {
    /**
     * Get store fav image
     */
    getStorefeaturedImage(images) {
     return Helpers.getStoreFeaturedImage(images);
    },

    async gotoStoreLanding(item) {
      this.va_spinner(true);
      // Get the location details from slug, store it and go
      let location = await LocationApis.fetchBySlug(item.slug);
      this.va_spinner(false);
      if(location.status == 200 ){
        // set this store as current store
        await this.va_setSelectedLocation(location.data.payload);
        this.$router.push({
          name: 'StoreLanding',
          params: { 
            business_slug: this.$route.params.business_slug,
            store_slug: item.slug 
          },
          query: this.$route.query,
        });
      } else {
        this.va_snackbar({
          type: "warning",
          message: "Cannot find the store for this business."
        });
      }
    },
    
    ...mapActions({
      va_setSelectedLocation: "location/setSelected",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar"
    })

  }
};
</script>

<style scoped>
.sm-no-padding{
    margin-left: 0;
    margin-right: 0;
}
.slider-wrapper {
    position: relative;
    margin: 0 -10px;
}
.text-center{
  text-align: center;
}
.location-address h3, 
.location-address p {
    width: 100%;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.store-nearby-wrapper .nav-button.button-next img{
  position: relative;
  right: -1px;
  width: 11px;
}
</style>